var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tgfGraphics } from "../framework/tgfGraphics";
import { tbBase } from "./tbBase";
import { getPIXIObjectFromTbObject } from "./tbGetPIXIObject";
import { PIXI } from "./tbPIXI";
var tbContainer = /** @class */ (function (_super) {
    __extends(tbContainer, _super);
    function tbContainer(width, height) {
        if (width === void 0) { width = 100; }
        if (height === void 0) { height = 100; }
        var _this = _super.call(this) || this;
        _this.width = width;
        _this.height = height;
        _this.x = 0;
        _this.y = 0;
        _this.pivotX = 0;
        _this.pivotY = 0;
        _this.scaleX = 1;
        _this.scaleY = 1;
        _this.alpha = 1;
        _this.container = new PIXI["Container"]();
        _this.setSize(_this.width, _this.height);
        return _this;
    }
    tbContainer.prototype.setPivot = function (x, y) {
        this.pivotX = x;
        this.pivotY = y;
        this.container["pivot"]["x"] = this.pivotX;
        this.container["pivot"]["y"] = this.pivotY;
    };
    tbContainer.prototype.setSize = function (width, height) {
        this.width = width;
        this.height = height;
        this.container["width"] = this.width;
        this.container["height"] = this.height;
    };
    tbContainer.prototype.setPosition = function (x, y) {
        this.x = x;
        this.y = y;
        if (this.container) {
            this.container["x"] = this.x;
            this.container["y"] = this.y;
        }
    };
    tbContainer.prototype.setScale = function (x, y) {
        this.scaleX = x;
        this.scaleY = y;
        if (this.container) {
            this.container["scale"]["x"] = this.scaleX;
            this.container["scale"]["y"] = this.scaleY;
        }
    };
    tbContainer.prototype.setRotation = function (rotation) {
        if (this.container) {
            this.container["rotation"] = rotation;
            this.rotation = rotation;
        }
    };
    tbContainer.prototype.show = function () {
        if (this.container) {
            this.container["visible"] = true;
        }
    };
    tbContainer.prototype.hide = function () {
        if (this.container) {
            this.container["visible"] = false;
        }
    };
    tbContainer.prototype.setTint = function (tint) {
        if (this.container && tint) {
            this.container["tint"] = tint;
        }
    };
    tbContainer.prototype.setMask = function (mask) {
        if (this.container && mask) {
            this.container["mask"] = mask;
        }
    };
    tbContainer.prototype.setAlpha = function (alpha) {
        this.alpha = Math.min(Math.max(alpha, 0), 1);
        this.container["alpha"] = this.alpha;
    };
    tbContainer.prototype.addChild = function (child) {
        if (!this.container) {
            return;
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            this.container["addChild"](child);
        }
        else {
            throw new Error("Failed to add child to container");
        }
    };
    tbContainer.prototype.removeChild = function (child) {
        if (!this.container) {
            return;
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            this.container["removeChild"](child);
        }
    };
    /**
     * Add this image to the given container.
     * It will add itself directly to the main canvas if the container is invalid.
     */
    tbContainer.prototype.add = function (container) {
        if (!this.container) {
            return;
        }
        if (container === null || container === void 0 ? void 0 : container["addChild"]) {
            container["addChild"](this.container);
        }
        else {
            tgfGraphics.addChild(this.container);
        }
    };
    tbContainer.prototype.remove = function (container) {
        if (!this.container) {
            return;
        }
        if (container === null || container === void 0 ? void 0 : container["removeChild"]) {
            container["removeChild"](this.container);
        }
        else {
            tgfGraphics.removeChild(this.container);
        }
    };
    tbContainer.prototype.free = function (alsoChildren) {
        if (alsoChildren === void 0) { alsoChildren = true; }
        var options = {
            "children": alsoChildren,
            "texture": false,
            "baseTexture": false
        };
        if (this.container) {
            this.container["destroy"](options);
            this.container = null;
        }
    };
    tbContainer.prototype.clone = function () {
        return new tbContainer(this.width, this.height);
    };
    return tbContainer;
}(tbBase));
export { tbContainer };
